<template>
  <div class="image-composition">
    <ModuleTitle
      :subTitle="
        !props.character?.config?.is_special_outfit
          ? $t('sui-xin-deng-zhi-ren-wu-tao-zhuang-fa-xing-pei-shi-zhuang-rong-mian-rong')
          : $t('dang-qian-ren-wu-jin-zhan-shi-bu-ke-bian-ji')
      "
      class="m-only"
    >
      {{ $t('jiao-se-xing-xiang-gou-cheng') }}
    </ModuleTitle>
    <div class="pc-only image-composition__title">
      <h3>
        {{ $t('jiao-se-xing-xiang-gou-cheng') }}
      </h3>
      <p>
        {{
          !props.character?.config?.is_special_outfit
            ? $t('sui-xin-deng-zhi-ren-wu-tao-zhuang-fa-xing-pei-shi-zhuang-rong-mian-rong')
            : $t('dang-qian-ren-wu-jin-zhan-shi-bu-ke-bian-ji')
        }}
      </p>
    </div>
    <ImageM v-bind="props" class="m-only" />
    <ImagePc v-bind="props" class="pc-only" @create-work="emit('create-work')" />
  </div>
</template>
<script lang="ts" setup>
import type { Character, CharacterXihe } from '~/api/interface/character';
import ModuleTitle from '../module-title.vue';
import ImageM from './images-m.vue';
import ImagePc from './images-pc.vue';

interface ImageCompositionProps {
  character?: Character | null;
  characterXihe?: CharacterXihe;
}

const props = defineProps<ImageCompositionProps>();
const emit = defineEmits(['create-work']);
</script>
<style lang="scss" scoped>
.image-composition {
  @apply flex-col items-center w-full py-[160px];
  // 还原移动端样式
  @media (max-width: 680px) {
    padding: 0;
  }
  .image-composition__title {
    @apply flex flex-col items-center;
    gap: 16px;
    h3 {
      margin: 0;
      color: var(--x-text-1);
      font-size: 48px;
      font-style: normal;
      font-weight: 400;
      list-style: normal;
    }
    p {
      color: var(--x-text-5);
      font-size: 20px;
      font-weight: 400;
      font-style: normal;
      line-height: normal;
      margin: 0;
    }
  }
}
.image-composition-content {
  @apply mt-[46px] sm:px-[20px] grid grid-cols-5 sm:grid-cols-2 gap-[20px] w-[1200px] sm:w-full mx-auto relative;
  grid-auto-rows: 224px;
  @media (max-width: 680px) {
    grid-auto-rows: vw(165);
  }
}

.image-card {
  @apply rounded-[8px] p-[12px] relative;
  border: 1px solid var(--back-4);
  grid-column: span 1;
  grid-row: span 1;
  transition: all 0.3s ease;
  order: 2;

  &.active {
    grid-column: span 2;
    grid-row: span 2;
    .edit-btn {
      display: block;
    }
  }

  &.default-card {
    @apply sm:order-1;
  }

  &:hover .edit-btn {
    display: block;
  }

  .edit-btn {
    display: none;
    // @media (min-width: 681px) {
    // display: block;
    // }
  }
}
</style>
